<template>
	<div class="scrollbar-killer">
		<div class="video-container">
			<div class="video-embed-object-fit-cover">
				<iframe
					:src="
						'https://player.vimeo.com/video/' +
						video +
						'?loop=1&muted=1&badge=0&autoplay=1&controls=0&autopause=0&player_id=0'
					"
					frameborder="0"
					controls="0"
				></iframe>
			</div>
		</div>
	</div>
</template>

<script setup>
defineProps({
	video: { type: String, default: '' },
	type: { type: String, default: '' },
});
</script>

<style>
.scrollbar-killer {
	position: absolute;
	inset: 0;
	overflow: hidden;
}

.video-container {
	position: relative;
	top: 0;
	left: 0;
	width: 100%;
	height: 101%;
}

.video-embed-object-fit-cover {
	position: absolute;
	inset: 0;
	width: 100%;
	height: 100%;
	container-type: size;
	overflow: hidden;
}

.video-embed-object-fit-cover > iframe {
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
	width: 100%;
	height: 100%;

	@container (min-aspect-ratio: 16 / 9) {
		height: 56.25cqw;
	}

	@container (max-aspect-ratio: 16 / 9) {
		width: 177.78cqh;
	}

	pointer-events: none;
}
</style>
